interface TrainerBadgeProps {
  initials: string;
  color: string;
  name?: string;
  size?: "small" | "medium";
}

const SIZES = {
  small: "w-6 h-6 text-[10px]",
  medium: "w-8 h-8 text-xs",
};

export function TrainerBadge({ initials, color, name, size = "small" }: TrainerBadgeProps) {
  return (
    <div
      title={name}
      className={`${SIZES[size]} rounded-full flex items-center justify-center font-bold text-white shrink-0`}
      style={{ backgroundColor: color }}
    >
      {initials}
    </div>
  );
}
